import React from 'react';

import { Lottie } from '@whelk/components';
import EarthDarkLottie from './json/earth-dark.json';
import EarthLightLottie from './json/earth-light.json';
import { useTheme } from 'next-themes';
import ReadDarkLottie from './json/read-dark.json';
import ReadLightLottie from './json/read-light.json';
import FinishDarkLottie from './json/finish-dark.json';
import FinishLightLottie from './json/finish-light.json';
import ThinkDarkLottie from './json/think-dark.json';
import ThinkLightLottie from './json/think-light.json';
import ChatLoadingDarkLottie from './json/msgLoading-dark.json';
import ChatLoadingLightLottie from './json/msgLoading.json';

export const ChatEarthLottie = () => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  return (
    <Lottie
      style={{ padding: '1px 0px', width: '24px' }}
      data={isDark ? EarthDarkLottie : EarthLightLottie}
      play={true}
    />
  );
};

export const ChatReadLottie = () => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  return (
    <Lottie
      style={{ padding: '1px 0px', width: '24px' }}
      data={isDark ? ReadDarkLottie : ReadLightLottie}
      play={true}
    />
  );
};

export const ChatFinishLottie = () => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  return (
    <Lottie
      style={{ padding: '1px 0px', width: '24px' }}
      data={isDark ? FinishDarkLottie : FinishLightLottie}
      loop={false}
      play={true}
    />
  );
};

// think
export const ChatThinkLottie = () => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  return (
    <Lottie
      style={{ padding: '1px 0px', width: '24px' }}
      data={isDark ? ThinkDarkLottie : ThinkLightLottie}
      play={true}
    />
  );
};

export const ChatLoading = () => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';
  return (
    <Lottie
      style={{ padding: '1px 0px', width: '48px' }}
      data={isDark ? ChatLoadingDarkLottie : ChatLoadingLightLottie}
      play={true}
    />
  );
};
